import React from "react";
import stl from "./productInTable.module.scss";
import ProductItem from "./ProductItem";
import ProductInTableSkeleton from "./ProductInTableSkeleton";
import classnames from "classnames";

interface IProps {
    data: any[];
    type: string;
    fetchedProducts?: boolean; // true=已经获取过产品
}

const ProductList: React.FC<IProps> = (props) => {
    const { data, type, fetchedProducts = false } = props;
    return (
        <div
            className={classnames(stl["like-product-list"], {
                ["hidden"]: fetchedProducts && data.length <= 0,
            })}
        >
            {data.length > 0 ? (
                data.map((item: any, index: number) => (
                    <ProductItem key={index} data={item} type={type} />
                ))
            ) : (
                <ProductInTableSkeleton />
            )}
        </div>
    );
};

export default ProductList;
